@if (isPopupMode()) {
  <div
    class="note-overlay"
    [class.is-open]="isOpen()"
    (click)="onBackdropClick()"
  >
    <div
      class="note-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="i18n.t().noteModalDialogAria"
      [class.is-fullscreen]="isFullscreen()"
      (click)="$event.stopPropagation()"
    >
      <header class="note-header">
        <div class="note-title">
          <p
            class="note-subtitle"
            [class.is-empty]="!noteSubtitle()"
            [innerHTML]="subtitleHtml()"
          ></p>
        </div>
        <div class="note-actions">
          <button
            class="note-icon-button note-fullscreen"
            type="button"
            [attr.aria-label]="
              isFullscreen()
                ? i18n.t().noteModalExitFullscreenAria
                : i18n.t().noteModalEnterFullscreenAria
            "
            [attr.aria-pressed]="isFullscreen()"
            (click)="onToggleFullscreenClick()"
          >
            @if (isFullscreen()) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M3.29 3.29C3.11 3.46 3.01 3.7 3 3.94C2.98 4.19 3.06 4.43 3.22 4.63L3.29 4.7L7.58 8.99H5C4.73 8.99 4.48 9.1 4.29 9.29C4.1 9.47 4 9.73 4 9.99C4 10.26 4.1 10.51 4.29 10.7C4.48 10.89 4.73 10.99 5 10.99H11V4.99C11 4.73 10.89 4.47 10.7 4.29C10.51 4.1 10.26 3.99 10 3.99C9.73 3.99 9.48 4.1 9.29 4.29C9.1 4.47 9 4.73 9 4.99V7.58L4.7 3.29L4.63 3.22C4.43 3.06 4.19 2.98 3.94 3C3.7 3.01 3.46 3.11 3.29 3.29ZM19 13H13V19C13 19.26 13.1 19.51 13.29 19.7C13.48 19.89 13.73 20 14 20C14.26 20 14.51 19.89 14.7 19.7C14.89 19.51 15 19.26 15 19V16.41L19.29 20.7L19.36 20.77C19.56 20.92 19.8 21 20.04 20.99C20.29 20.98 20.52 20.87 20.7 20.7C20.87 20.52 20.98 20.29 20.99 20.04C21 19.8 20.92 19.56 20.77 19.36L20.7 19.29L16.41 15H19C19.26 15 19.51 14.89 19.7 14.7C19.89 14.51 20 14.26 20 14C20 13.73 19.89 13.48 19.7 13.29C19.51 13.1 19.26 13 19 13Z"
                  fill="currentColor"
                />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M10 3H3V10C3 10.26 3.1 10.51 3.29 10.7C3.48 10.89 3.73 11 4 11C4.26 11 4.51 10.89 4.7 10.7C4.89 10.51 5 10.26 5 10V6.41L9.29 10.7L9.36 10.77C9.56 10.92 9.8 11 10.04 10.99C10.29 10.98 10.52 10.87 10.7 10.7C10.87 10.52 10.98 10.29 10.99 10.04C11 9.8 10.92 9.56 10.77 9.36L10.7 9.29L6.41 5H10C10.26 5 10.51 4.89 10.7 4.7C10.89 4.51 11 4.26 11 4C11 3.73 10.89 3.48 10.7 3.29C10.51 3.1 10.26 3 10 3ZM20 13C19.73 13 19.48 13.1 19.29 13.29C19.1 13.48 19 13.73 19 14V17.58L14.7 13.29L14.63 13.22C14.43 13.07 14.19 12.99 13.95 13C13.7 13.01 13.47 13.12 13.29 13.29C13.12 13.47 13.01 13.7 13 13.95C12.99 14.19 13.07 14.43 13.22 14.63L13.29 14.7L17.58 19H14C13.73 19 13.48 19.1 13.29 19.29C13.1 19.48 13 19.73 13 20C13 20.26 13.1 20.51 13.29 20.7C13.48 20.89 13.73 21 14 21H21V14C21 13.73 20.89 13.48 20.7 13.29C20.51 13.1 20.26 13 20 13Z"
                  fill="currentColor"
                />
              </svg>
            }
          </button>
          <button
            class="note-icon-button note-close"
            type="button"
            [attr.aria-label]="i18n.t().noteModalCloseAria"
            (click)="onCloseClick()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              aria-hidden="true"
              focusable="false"
            >
              <line
                x1="16"
                y1="16"
                x2="48"
                y2="48"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
              />
              <line
                x1="48"
                y1="16"
                x2="16"
                y2="48"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
      </header>

      <div class="note-content">
        <div class="note-editor-wrapper">
          <ngx-editor-menu
            [editor]="editor"
            [toolbar]="toolbar"
          ></ngx-editor-menu>
          <ngx-editor
            class="note-editor"
            data-testid="mindmap-note-editor"
            [editor]="editor"
            [formControl]="control"
            [placeholder]="i18n.t().noteModalPlaceholder"
          ></ngx-editor>
        </div>
      </div>
    </div>
  </div>
} @else {
  <section class="note-page-shell">
    <div
      class="note-dialog note-page-dialog"
      role="region"
      [attr.aria-label]="i18n.t().noteModalEditorRegionAria"
      [class.is-fullscreen]="isFullscreen()"
    >
      <header class="note-header">
        <div class="note-title">
          <p
            class="note-subtitle"
            [class.is-empty]="!noteSubtitle()"
            [innerHTML]="subtitleHtml()"
          ></p>
        </div>
        <div class="note-actions">
          <button
            class="note-icon-button note-fullscreen"
            type="button"
            [attr.aria-label]="
              isFullscreen()
                ? i18n.t().noteModalExitFullscreenAria
                : i18n.t().noteModalEnterFullscreenAria
            "
            [attr.aria-pressed]="isFullscreen()"
            (click)="onToggleFullscreenClick()"
          >
            @if (isFullscreen()) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M3.29 3.29C3.11 3.46 3.01 3.7 3 3.94C2.98 4.19 3.06 4.43 3.22 4.63L3.29 4.7L7.58 8.99H5C4.73 8.99 4.48 9.1 4.29 9.29C4.1 9.47 4 9.73 4 9.99C4 10.26 4.1 10.51 4.29 10.7C4.48 10.89 4.73 10.99 5 10.99H11V4.99C11 4.73 10.89 4.47 10.7 4.29C10.51 4.1 10.26 3.99 10 3.99C9.73 3.99 9.48 4.1 9.29 4.29C9.1 4.47 9 4.73 9 4.99V7.58L4.7 3.29L4.63 3.22C4.43 3.06 4.19 2.98 3.94 3C3.7 3.01 3.46 3.11 3.29 3.29ZM19 13H13V19C13 19.26 13.1 19.51 13.29 19.7C13.48 19.89 13.73 20 14 20C14.26 20 14.51 19.89 14.7 19.7C14.89 19.51 15 19.26 15 19V16.41L19.29 20.7L19.36 20.77C19.56 20.92 19.8 21 20.04 20.99C20.29 20.98 20.52 20.87 20.7 20.7C20.87 20.52 20.98 20.29 20.99 20.04C21 19.8 20.92 19.56 20.77 19.36L20.7 19.29L16.41 15H19C19.26 15 19.51 14.89 19.7 14.7C19.89 14.51 20 14.26 20 14C20 13.73 19.89 13.48 19.7 13.29C19.51 13.1 19.26 13 19 13Z"
                  fill="currentColor"
                />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M10 3H3V10C3 10.26 3.1 10.51 3.29 10.7C3.48 10.89 3.73 11 4 11C4.26 11 4.51 10.89 4.7 10.7C4.89 10.51 5 10.26 5 10V6.41L9.29 10.7L9.36 10.77C9.56 10.92 9.8 11 10.04 10.99C10.29 10.98 10.52 10.87 10.7 10.7C10.87 10.52 10.98 10.29 10.99 10.04C11 9.8 10.92 9.56 10.77 9.36L10.7 9.29L6.41 5H10C10.26 5 10.51 4.89 10.7 4.7C10.89 4.51 11 4.26 11 4C11 3.73 10.89 3.48 10.7 3.29C10.51 3.1 10.26 3 10 3ZM20 13C19.73 13 19.48 13.1 19.29 13.29C19.1 13.48 19 13.73 19 14V17.58L14.7 13.29L14.63 13.22C14.43 13.07 14.19 12.99 13.95 13C13.7 13.01 13.47 13.12 13.29 13.29C13.12 13.47 13.01 13.7 13 13.95C12.99 14.19 13.07 14.43 13.22 14.63L13.29 14.7L17.58 19H14C13.73 19 13.48 19.1 13.29 19.29C13.1 19.48 13 19.73 13 20C13 20.26 13.1 20.51 13.29 20.7C13.48 20.89 13.73 21 14 21H21V14C21 13.73 20.89 13.48 20.7 13.29C20.51 13.1 20.26 13 20 13Z"
                  fill="currentColor"
                />
              </svg>
            }
          </button>
          <button
            class="note-icon-button note-close"
            type="button"
            [attr.aria-label]="i18n.t().noteModalCloseAria"
            (click)="onCloseClick()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              aria-hidden="true"
              focusable="false"
            >
              <line
                x1="16"
                y1="16"
                x2="48"
                y2="48"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
              />
              <line
                x1="48"
                y1="16"
                x2="16"
                y2="48"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
      </header>

      <div class="note-content">
        <div class="note-editor-wrapper">
          <ngx-editor-menu
            [editor]="editor"
            [toolbar]="toolbar"
          ></ngx-editor-menu>
          <ngx-editor
            class="note-editor"
            data-testid="mindmap-note-editor"
            [editor]="editor"
            [formControl]="control"
            [placeholder]="i18n.t().noteModalPlaceholder"
          ></ngx-editor>
        </div>
      </div>
    </div>
  </section>
}
